import styled from 'styled-components';

export const ChartContainer = styled.div`
  margin-bottom: 10px;
  width: 49%;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px;
  height: 450px;
`;
